// extracted by mini-css-extract-plugin
export default {"header":"Question_header__5P8yi","content":"Question_content__ioZKb","show":"Question_show__r9Viq","hiden":"Question_hiden__LS2dD","footer":"Question_footer__81maN"};